// extracted by mini-css-extract-plugin
export default {"loader":"Pagination_loader__UmKsp","l20-1":"Pagination_l20-1__NrdEH","l20-2":"Pagination_l20-2__gndAh","theme-grayscale":"Pagination_theme-grayscale__-HXeg"};